export async function readJSON(parameter, onLoad) {
    try {
        const response = await fetch(parameter);
        if (!response.ok) {
            console.log("data path doesn't exist");
            throw new Error('Network response was not ok');
        }
        
        const blob = await response.blob();
        const text = await new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.onloadend = () => {
                if (fileReader.result !== null) {
                    resolve(fileReader.result);
                } else {
                    reject(new Error('Failed to read file'));
                }
            };
            fileReader.onerror = () => reject(new Error('Failed to read file'));
            fileReader.readAsText(blob);
        });

        // If callback is provided, use it
        if (typeof onLoad === 'function') {
            onLoad(text);
        }
        
        // Always return the result for Promise-based usage
        return text;
    } catch (error) {
        console.error('There has been a problem with your fetch operation:', error);
        throw error;
    }
}